import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResCurrency } from '@app/reservation/models/res-owner.model';
import { CoreUtilityDialog, EidosUtilityService } from '@app/core/services/eidos-utility.service';
import { EidosModalService } from '@app/core/components/eidos-modal/eidos-modal.service';
import { DateTime } from 'luxon';
import { ReservationPermission } from '../models/reservation-permission.model';
import { IEidosEnvironment } from '@app/core/config/environment.interface';
import { EidosConfigService } from '@app/core/config/eidos-config.service';
import { IReservationCompany } from '@app/reservation/models/res-cached-data.models';
import { ReservationProductCalendarVoyage } from '@app/reservation/models/res-product.models';

@Injectable({
  providedIn: 'root'
})
export class RescomService {

  utilityDialogs: CoreUtilityDialog;

  public uniqueContainer = new BehaviorSubject<{category:string,key:string}>({category:'',key:''})

  onSelectedCalendarVoyageChange = new BehaviorSubject<ReservationProductCalendarVoyage|null>(null);
  public allAvailableCompanies: BehaviorSubject<IReservationCompany[]> = new BehaviorSubject<IReservationCompany[]>([]);

  constructor(
    private eidosModalService: EidosModalService,
    private coreUtilityService: EidosUtilityService,
    private eidosConfigService: EidosConfigService
  ) {
    this.utilityDialogs = new CoreUtilityDialog(this.eidosModalService);
    this.config = this.eidosConfigService.currentConfig.getValue();
  }
  isCoxAndKings(companyID:number) {
    return companyID === 2900 || companyID === 2901 ||  companyID === 2902
  }
  isCoxAndKingsUk(companyID:number) {
    return companyID === 2900
  }
  public getAvailableCompanies() {
    return this.coreUtilityService.getAvailableCompanies();
  }

  allValidCurrencies: BehaviorSubject<Array<ResCurrency>> = new BehaviorSubject<Array<ResCurrency>>([]);

  currentReservationPermission: BehaviorSubject<ReservationPermission> = new BehaviorSubject<ReservationPermission>(ReservationPermission.emptyPermission());

  companyDataReload = new BehaviorSubject<boolean>(false);

  protected config: IEidosEnvironment | undefined;

  public static buildDateRange(d1: DateTime, d2?: DateTime) {
    if (!d1 && !d2) return [];
    if (!d2) return [d1];
    let days = d2.diff(d1, 'days').days;
    let dateRange = [];
    for (let i = 0; i <= days; i++) {
      dateRange.push(d1.plus({ days: i }));
    }
    return dateRange;
  }

  public static getNumberFromString(str: string): number {
    const number = Number(str.replace(/[^0-9.-]+/g, ''))
    return !isNaN(number) ? number : 0;
  }

  public downloadBlobFile(guid: string) {
    return `${this.config?.urlAPI}/documents/document-blob-guid?FileGuid=${guid}`;
  }

  public downloadBlobFileNew(guid: string, inlineOpening = true) {
    return `${this.config?.uploadUrlAPI}/documents/document-blob-guid-nocs?FileGuid=${guid}&fileInline=${inlineOpening}`;
  }

  public downloadExcel(objectKey: string, params?: any){
    let url = `${this.config?.urlAPI}/io/excel/export?ObjectKey=${objectKey}`;
    if(params){
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          const v = value as any
          if (!!v.plus && !!v.toFormat) {
            url = url + `&${key}=${v.toISODate()}`
          } else {
            url = url + `&${key}=${value}`
          }
        }
      });
    }
    console.log("URL CREATO: ",url)
    return url
  }
  public currentCompany = new BehaviorSubject<IReservationCompany | undefined>(undefined);

}
